import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import Breadcrumbs from '../../components/Breadcrumbs';
import Utils from '../../utils';

const mapStateToProps = (state: StoreState) => {
	const { driveList, galleryInfos, routerParamsHistory } = state;
	const { config, config: { applicationGallery: galleryId } } = galleryInfos;
	const { driveItems, isEditMode } = driveList;
	const privateDirId = Utils.getPrivateDirId(driveList, config);
	const sharedDirId = Utils.getSharedDirId(driveList, galleryInfos);
	const currentFolderId = Utils.getCurrentFolderId(galleryId, routerParamsHistory);

	return {
		galleryId,
		sharedDirId,
		currentFolderId,
		driveItems,
		privateDirId,
		isEditMode
	};
};

export default connect(mapStateToProps)(Breadcrumbs);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Breadcrumbs/index.tsx